import cx from 'classnames'

import styles from '../actionIcons.module.scss'

import { CommentView } from './CommentView'

export function Comment ({ onClick, item, selected, parentItem }) {
  const handleClick = () => e => {
    e.cancelBubble = true
    if (e.stopPropagation) e.stopPropagation()
    let id
    if (selected) {
      id = null
    } else id = parentItem ? parentItem.id : item.id
    onClick(id)
  }

  return (
    <button
      className={cx(styles.actionIcon, styles.commentIcon, {
        [styles.open]: selected,
        [styles.draft]: item?.comment?.some(c => c.draft),
        [styles.commentExist]: item.comment?.length > 0
      })}
      data-role='comment-icon'
      onClick={handleClick()}
    >
      <CommentView
        item={item}
        selected={selected}
      />
    </button>
  )
}
